import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { postRelatives, postNewRelative, delByPathId } from 'services/api';
import { normalizeRelativesList } from './operations';

export interface RelativesState {
  relativeList: {
    data: any;
    filterableValues: any,
    pagination: {
      total: number;
      page: number;
    },
    status: null | 'idle' | 'loading' | 'failed',
  }
}

const initialState: RelativesState = {
  relativeList: {
    data: [],
    filterableValues: {},
    pagination: {
      total: 0,
      page: 1,
    },
    status: null,
  },
};

export const postRelativesAsync: any | null = createAsyncThunk(
  'relatives/postRelatives',
  async (data: any) => {
    const response = await postRelatives(data);
    return response?.data;
  },
);

export const postNewRelativeAsync: any | null = createAsyncThunk(
  'relatives/postNewRelative',
  async (data: any) => {
    const response = await postNewRelative(data);
    return response;
  },
);

export const delByPathIdRelativeAsync: any | null = createAsyncThunk(
  'relatives/delByPathId',
  async (data: any) => {
    const response = await delByPathId(data.path, data.id);
    return response;
  }
);

export const relativesSlice = createSlice({
  name: 'relatives',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postRelativesAsync.pending, (state) => {
        state.relativeList.status = 'loading';
      })
      .addCase(postRelativesAsync.fulfilled, (state, action) => {
        state.relativeList.data = normalizeRelativesList(action.payload);
        state.relativeList.filterableValues = action.payload?.item?.filterableValues;
        state.relativeList.pagination.total = action.payload?.item?.total;
        state.relativeList.status = 'idle';
      })
      .addCase(postRelativesAsync.rejected, (state) => {
        state.relativeList.status = 'failed';
      })
      .addCase(delByPathIdRelativeAsync.fulfilled, (state, action) => {
        state.relativeList.data = state.relativeList.data.filter((item: any) => item.id !== action.meta.arg.id);
      })
  }
});

export default relativesSlice.reducer;
